module.exports = __webpack_public_path__ + "static/img/can-lime.c1fe5be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-lime.png
// module id = eYc8
// module chunks = 0